import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { Validator } from "../../snippets/Validator";

export class MaintenanceReport extends CRUDEntity {

    #validationFields = [
        'maintenance_date',
        'mileage',
        'vehicle_id'
    ]

    constructor(id=null) {
        Object.assign(MaintenanceReport.prototype, FormActions);
        Object.assign(MaintenanceReport.prototype, EntityModalForm);
        Object.assign(MaintenanceReport.prototype, HasAttachments);

        super();
        this.entityClass = 'maintenance-report';
        this.urlRoot = '/vehicles-management/maintenance-report';
        this.sectionRootUrl = '/vehicles-management';
        this.id = id;
        this.setAttachmentCallbackDelete();
        this.setAttachmentCallbackPreview();
        MaintenanceReport.prototype.delegatedListnersForButtons = function(type, entityClass) {
            daterangepicker.setPicker($('input#maintenance-report_date'), 'MM/DD/YYYY');

            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validationFields){
                $(`#${type}-${entityClass} [name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()

            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type == 'create') 
                        this.create(()=>setTimeout(() => window.location.reload(), 500));
                    if (type == 'edit') 
                        this.update(()=>setTimeout(() => window.location.reload(), 500));
                }
            });
        }
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            'maintenance_date': ['required'],
            'mileage': ['required', {regexp: /^[0-9]+$/}],
            'vehicle_id':['required']
        });
        let validateFlag = true;
        this.#validationFields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','');
            }else{
                validateFlag = false;
                if(isSelectErrorFields)
                    $(`#${formId} [name="${element}"]`).attr('style','border:2px solid #DB3A57 !important;');
            }
        });
        return validateFlag;
    }
}